




import { Component, Vue } from "vue-property-decorator";
import { OrganisationModel, PrivatePersonModel } from "../models";
import { namespace } from "vuex-class";

import RelationData from "modules/relationprofile/components/RelationData.vue";
import { getProfile } from "shared/api";
import { RelationType } from "shared/store/auth/types";

const opStore = namespace("relationprofile");
const snackStore = namespace("snackbar");

@Component({
  components: { RelationData },
})
export default class MyOrganisation extends Vue {
  @opStore.Getter currentOrganisation!: OrganisationModel;
  @opStore.Getter currentPrivatePerson!: PrivatePersonModel;

  @opStore.Action fetchCurrentOrganisation!: () => Promise<void>;
  @opStore.Action fetchCurrentPrivatePerson!: () => Promise<void>;

  @snackStore.Mutation defaultError!: () => void;

  private RelationType: typeof RelationType = RelationType;
  private currentType = "";

  get currentRelation(): OrganisationModel | PrivatePersonModel {
    return this.currentType === RelationType.private
      ? this.currentPrivatePerson
      : this.currentOrganisation;
  }

  async mounted(): Promise<void> {
    try {
      const profile = await getProfile();
      this.currentType = profile.relation_type;
      if (profile.relation_type === RelationType.contact) {
        this.fetchCurrentOrganisation();
      } else {
        this.fetchCurrentPrivatePerson();
      }
    } catch (e) {
      this.defaultError();
    }
  }
}
